import { FC } from 'react'
import StyledButton, { StyledButtonProps } from '@organs/StyledButton'
import ButtonStyle from '@enums/ButtonStyle'

type Props = Omit<StyledButtonProps, 'buttonStyle'>

const SecondaryButton: FC<Props> = (props) => (
  <StyledButton {...props} buttonStyle={ButtonStyle.SECONDARY} />
)

export type { Props as SecondaryButtonProps }
export default SecondaryButton
